import e from"styled-components";const t=e("div")`
  position: relative;
  padding: 80px 0;
  color: ${({theme:e,contentColor:t})=>"light"===t?e.palette.white.main:e.palette.black80.main};
  background: ${({theme:e,contentColor:t})=>"light"===t?e.palette.blue80.main:e.palette.black10.main}
    url(${({desktopBg:e})=>e}) no-repeat center/cover;

  &::after {
    position: absolute;
    inset: 0;
    z-index: 10;
    display: ${({imageLayer:e})=>e?"block":"none"};
    content: '';
    background-color: ${({theme:e,imageLayer:t})=>e.palette?.[t]?.main};
    opacity: 0.8;
  }

  ${({theme:e})=>e.breakpoints.down("md")} {
    padding: 60px 0;
    background-image: url(${({tabletBg:e,desktopBg:t})=>e||t});
  }

  ${({theme:e})=>e.breakpoints.down("md")} {
    padding: 40px 0;
    background-image: url(${({mobileBg:e,desktopBg:t})=>e||t});
  }
`,n=e("h1")`
  position: relative;
  z-index: 5;
  max-width: 840px;
  margin: ${({alignment:e})=>"center"===e?"0 auto":"0"};
  font-size: ${({theme:e})=>e.typography.h1.fontSize};
  font-weight: ${({theme:e})=>e.typography.fontWeightLight};
  hyphens: auto;
  line-height: 1.1;
  color: inherit;
  text-align: ${({alignment:e})=>e};

  ${({theme:e})=>e.breakpoints.down("md")} {
    font-size: ${({theme:e})=>e.typography.h4.fontSize};
  }

  span {
    padding: 0 10px;
    font-weight: ${({theme:e})=>e.typography.h1.fontWeight};
    line-height: 1.5;
    color: ${({theme:e})=>e.palette.blue100.main};
    text-transform: uppercase;
    background-color: ${({theme:e})=>e.palette.white.main};
    box-decoration-break: clone;
  }
`,o=e("p")`
  position: relative;
  z-index: 20;
  max-width: 840px;
  margin: 40px ${({alignment:e})=>"center"===e?"auto":"0"} 0;
  color: inherit;
  text-align: ${({alignment:e})=>e};

  ${({theme:e})=>e.breakpoints.down("md")} {
    margin: 30px ${({alignment:e})=>"center"===e?"auto":"0"} 0;
  }
`;export{o as DescriptionParagraph,n as Heading1,t as PageTitleDiv};
//# sourceMappingURL=styles.js.map
